/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { HStack, Button } from '@chakra-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useStoreActions, useStoreState } from '../../../../../models/hooks';
import { SelectMenu } from './SelectMenu';
import { PositionStatus } from '../types';
import { useCurrentUserProfile } from '../../../../../app/hooks/useCurrentUserProfile';
import { SelectLocation } from './SelectLocation';
import { JobSelect } from './JobSelect';
import { ProvinceSelect } from './ProvinceSelect';
import { SelectDistrict } from './DistrictSelect';

function PositionFiltersComponent() {
  const { t } = useTranslation('moniterByRecruiters');
  const { currentUserProfile } = useCurrentUserProfile();

  const accountId = currentUserProfile?.account;
  const { positionFilters, selectedRecruiters, isBulkAssignMode } = useStoreState((state) => state.moniterByRecruiters);
  const { setPositionFilter, resetPositionFilters, fetchPositions } = useStoreActions((state) => state.moniterByRecruiters);
  const isMonitorRecruitersFilterDistrictEnabled = useStoreState(
    (state) => state.app.accounts?.configuration?.isMonitorRecruitersFilterDistrictEnabled,
  );
  const POSITION_TYPE = [
    { value: 'open', label: t('filter.position.open') },
    { value: 'closed', label: t('filter.position.closed') },
    { value: 'archived', label: t('filter.position.archived') },
  ];

  React.useEffect(() => {
    resetPositionFilters();
  }, []);

  const isInitialMount = React.useRef(true);

  const handleFetchPosition = React.useCallback(
    // eslint-disable-next-line @typescript-eslint/no-inferrable-types
    (fromApplyFilter = false) => {
      if (accountId) {
        fetchPositions({ accountId, fromApplyFilter }).catch((err) => {
          console.error('Error fetching positions', err);
        });
      }
    },
    [accountId],
  );

  React.useEffect(() => {
    if (isInitialMount.current) return;

    if (selectedRecruiters.length === 0) {
      return;
    }

    handleFetchPosition();
  }, [positionFilters.page, positionFilters.limit, positionFilters.sortBy, positionFilters.sortOrder]);

  React.useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }

    if (isBulkAssignMode) {
      return;
    }

    if (selectedRecruiters.length === 0) {
      return;
    }

    handleFetchPosition();
  }, [selectedRecruiters, isBulkAssignMode]);

  return (
    <HStack bg="white" padding={2} borderRadius="md" mb="2px">
      <SelectLocation />
      <SelectMenu
        label={POSITION_TYPE?.find((e) => positionFilters?.positionStatus?.includes(e.value as PositionStatus))?.label ?? ''}
        variant="checkbox"
        selectAllLabel="All Position Status"
        selected={(positionFilters?.positionStatus as string[]) ?? []}
        options={POSITION_TYPE}
        onChange={(value) => {
          setPositionFilter({ key: 'positionStatus', value: value as PositionStatus[] });
        }}
        requireSelection
      />
      <JobSelect />
      <ProvinceSelect />

      {isMonitorRecruitersFilterDistrictEnabled && <SelectDistrict />}
      <HStack justify="flex-end">
        <Button
          size="sm"
          onClick={() => {
            resetPositionFilters();
          }}
        >
          {t('filter.reset')}
        </Button>
        <Button
          size="sm"
          colorScheme="blue"
          onClick={() => {
            handleFetchPosition(true);
          }}
        >
          {t('filter.apply')}
        </Button>
      </HStack>
    </HStack>
  );
}

export const PositionFilters = React.memo(PositionFiltersComponent);
